import { useEffect, useState } from 'react';

export const ProgressBar = ({
  currentPercentage,
  previousPercentage,
}: {
  currentPercentage: number;
  previousPercentage: number;
}): JSX.Element => {
  const [progress, setProgress] = useState(previousPercentage);

  useEffect(() => {
    if (Math.round(progress) < Math.round(currentPercentage)) {
      setProgress(progress + 1);
    }
  }, [currentPercentage, progress]);

  return (
    <div className="mb-4 h-2 w-full rounded-full bg-dawn-blue-200 shadow-xl">
      <div
        className="h-2 rounded-full bg-blue-800 transition-width duration-1000 ease-out"
        style={{ width: `${progress}%` }}
      />
    </div>
  );
};
